import { useEffect, useState } from 'react';
import { Button, ButtonStyles, ButtonWidth, Checkbox, Drawer, useTranslation } from '@nextgen-web-framework/all';
import HtmlContent from '../HtmlContent/HtmlContent';
import styles from './TermsAndConditionCheckBox.module.scss';

interface ITermsAndConditionCheckBoxPropTypes {
  tncText?: string;
  tncLinkText?: string;
  tncContent: string;
  disabled?: boolean;
  onCheckBoxClick?: (value: boolean) => void;
  checked?: boolean;
  wrapperClass?: string;
}

const TermsAndConditionCheckBox = ({
  tncText,
  tncLinkText,
  tncContent,
  disabled,
  onCheckBoxClick,
  checked = false,
  wrapperClass,
}: ITermsAndConditionCheckBoxPropTypes) => {
  const [checkboxValue, setCheckboxValue] = useState(checked);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const t = useTranslation();

  useEffect(() => {
    setCheckboxValue(checked);
  }, [checked]);

  const showTnc = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDrawerOpen(true);
  };

  const onClose = () => {
    setIsDrawerOpen(false);
    setCheckboxValue(true);
    onCheckBoxClick?.(true);
  };

  const onCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setCheckboxValue(e.target.checked);
    onCheckBoxClick?.(e.target.checked);
  };

  const checkboxDrawer = () => (
    <div data-testid="terms-and-condition-drawer">
      <Drawer
        header={t('profile.RegistrationIdVerificationStep.TNCModalHeading')}
        closeIcon
        data-testid="drawer-testid"
        bottomGap={0}
        onClose={onClose}
        closeOnBackdropClick
        useReactPortal
        portalContainerId={'react-portal-drawer'}
        footer={
          <Button
            title={t('profile.RegistrationIdVerificationStep.ButtonText')}
            buttonStyle={ButtonStyles.SOLID}
            onClick={onClose}
            buttonWidth={ButtonWidth.FULL_WIDTH}
            data-testid="next-button"
          />
        }
      >
        <div className={styles['tnc-content']}>
          <HtmlContent content={tncContent} />
        </div>
      </Drawer>
    </div>
  );

  return (
    <div className={`${styles['id-verification-tnc-checkbox']} ${wrapperClass}`} data-testid="tnc-checkbox-container">
      {isDrawerOpen && checkboxDrawer()}
      <Checkbox
        data-testid="tnc-checkbox"
        disabled={disabled}
        text={
          <div className={styles['tnc-text']}>
            <span className={`${styles['tnc-textlink']} ${checkboxValue ? styles['tnc-textlink-checked'] : ''}`}>
              {tncText}
              {/* eslint-disable jsx-a11y/anchor-is-valid */}
              <a
                className={styles['tnc-hyperlink']}
                role="presentation"
                onKeyDown={showTnc}
                onClick={!disabled ? showTnc : undefined}
                data-testid="tnc-checkbox-link"
              >
                {/* eslint-enable jsx-a11y/anchor-is-valid */}
                {tncLinkText}
              </a>
            </span>
          </div>
        }
        checked={checkboxValue}
        onChange={onCheckBoxChange}
      />
    </div>
  );
};

export default TermsAndConditionCheckBox;
